module.exports = __webpack_public_path__ + "img/logo.3e827428.png";